import { useEffect, useState } from "react";

const STORAGE_KEY = "cof_cookie_consent_v1";

function getMarketingConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return parsed?.marketing === true;
  } catch {
    return false;
  }
}

const MetaPixelLoader = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const loadPixel = () => {
      if (loaded) return; // već učitano
      if (!getMarketingConsent()) return;

      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

      window.fbq("init", "1641852960568805");
      window.fbq("track", "PageView");
      setLoaded(true);
    };

    loadPixel();

    // 🔔 Listener za kasnije prihvatanje
    const onConsentUpdate = () => loadPixel();
    window.addEventListener("cookie-consent-updated", onConsentUpdate);
    return () => window.removeEventListener("cookie-consent-updated", onConsentUpdate);
  }, [loaded]);

  return null;
};

export default MetaPixelLoader;
